"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function default_1({ settlementRequestType, roomId, commissionOrderId, }) {
    const isPaymentRequest = settlementRequestType === 'payment';
    const isCommissionWithdraw = settlementRequestType === 'commission';
    const postUrl = isPaymentRequest
        ? `/api/v1/room/${roomId}/payment-request`
        : `/api/v1/room/${roomId}/withdraw-request`;
    const returnUrl = isCommissionWithdraw
        ? `/room/${roomId}/settlement-manage/commissions/${commissionOrderId}`
        : `/room/${roomId}/settlement-manage`;
    return [postUrl, returnUrl];
}
exports.default = default_1;
